import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ShopProvider } from './shop/core/ShopProvider';
import { CartProvider } from './shop/core/cart/CartContext';
import { AuthProvider } from './auth/AuthContext';
import ScrollToTop from './components/ScrollToTop';
import Shop from './shop/pages/Shop';
import DetailsPage from './shop/pages/DetailsPage';
import Cart from './shop/pages/Cart';
import Checkout from './shop/pages/Checkout';
import PaymentSuccess from './shop/pages/PaymentSuccess';
import PaymentFailure from './shop/pages/PaymentFailure';
import PostsPage from './posts/pages/PostsPage';
import PostDetailPage from './posts/pages/PostDetailPage';
import ContactPage from './pages/contact';
import PrivacyPage from './components/PrivacyPolicy';
import ShippingPolicyPage from './components/ShippingPolicy';
import ReturnsPolicyPage from './components/ReturnsPolicy';
import CookiesPolicyPage from './components/CookiesPolicy';
import ShippingPage from './shipping/pages/ShippingPage';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import UserDashboard from './user/UserDashboard';
import RankRewards from './pages/RankRewards';
import AchievementDetail from './pages/AchievementDetail';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <ShopProvider>
      <CartProvider>
        <BrowserRouter>
          {/* Automatically scroll to top on route changes */}
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/rank-rewards" element={<RankRewards />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
            <Route path="/returns-policy" element={<ReturnsPolicyPage />} />
            <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/product/:id" element={<DetailsPage />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/shipping" element={<ShippingPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/failure" element={<PaymentFailure />} />
          {/* Redirect PayFast cancel back to failure page without reason param */}
          <Route path="/payment/cancel" element={<Navigate to="/payment/failure" replace />} />
            <Route path="/posts" element={<PostsPage />} />
            <Route path="/posts/:slug" element={<PostDetailPage />} />
              
              {/* Auth routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              
              {/* User dashboard routes */}
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/orders" element={<UserDashboard />} />
              <Route path="/user/leaderboard" element={<UserDashboard />} />
              <Route path="/user/rank-rewards" element={<UserDashboard />} />
              <Route path="/user/rules" element={<UserDashboard />} />
              
              {/* Achievement detail route */}
              <Route path="/achievement/:id" element={<AchievementDetail />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </ShopProvider>
    </AuthProvider>
  </React.StrictMode>
);
